<template>
    <!-- VBtn component is only used for esthetics -->
    <VBtn icon class="button-wrapper">
        <div class="radio" :class="{ selected: isActive }"></div>
    </VBtn>
</template>

<script>
export default {
    name: 'SrRadioActive',
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import '../../scss/variables';

.button-wrapper {
    margin: -8px;
}
.radio {
    height: 20px;
    border-radius: 50%;
    width: 20px;
    border: 2px solid rgba(0, 0, 0, 0.54);
    &.selected {
        height: 10px;
        width: 10px;
        border: 0 solid;
        background-color: $brand-red;
        box-shadow: 0 0 0 3px white, 0 0 0 5px $brand-red;
    }
}
</style>
